import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { QuantityValidationModal } from "./quantityValidationModal";
import BarcodeReader from "react-barcode-reader";
import SearchIcon from "@mui/icons-material/Search";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { setReturnedItems } from "../../product/all-products/redux/Actions/paginationActions";
import { useDispatch } from "react-redux";

export const OrderItemDetails = ({ data, returnItemArray, tableRef, open }) => {
  const [activeRow, setActiveRow] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [barcodeErr, setBarcodeErr] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const firstName = retailUserDetails?.firstName;
  const secondName = retailUserDetails?.secondName;
  const sessionId = localStorage.getItem("sessionId");
  const activeRowRef = useRef(null);

  useEffect(() => {
    if (!showModal || !open) {
      const handleKeyDown = (event) => {
        if (event.key === "ArrowUp") {
          setActiveRow((prev) => (prev > 0 ? prev - 1 : prev));
        } else if (event.key === "ArrowDown") {
          setActiveRow((prev) => (prev < data.length - 1 ? prev + 1 : prev));
        } else if (event.key === "Enter" && !showModal) {
          setShowModal(true);
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [data, showModal, open]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (tableRef?.current && activeRowRef?.current) {
      const tableBody = tableRef.current.querySelector(".custom-table-body");
      const activeRowElement = activeRowRef.current;

      if (activeRowElement && tableBody) {
        const offsetTop = activeRowElement.offsetTop;
        const scrollTop = tableBody.scrollTop;
        const tableHeight = tableBody.clientHeight;
        const rowHeight = activeRowElement.clientHeight;

        if (offsetTop < scrollTop) {
          tableBody.scrollTo({ top: offsetTop, behavior: "smooth" });
        } else if (offsetTop + rowHeight > scrollTop + tableHeight) {
          tableBody.scrollTo({ top: offsetTop + rowHeight - tableHeight, behavior: "smooth" });
        }
      }
    }
  }, [activeRow]);

  useEffect(() => {
    if (activeRowRef?.current) {
      setTimeout(() => {
        activeRowRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }, 0);
    }
  }, [activeRow]);

  const isItemReturned = (itemId, batchNo) => {
    return returnItemArray?.some((item) => item.gtin === itemId && item?.batchNo === batchNo);
  };

  const handleScan = (scannedGtin) => {
    const itemIndex = data?.findIndex((item) => item.gtin === scannedGtin);
    if (itemIndex !== -1) {
      setActiveRow(itemIndex);
      setShowModal(true);
      setBarcodeErr(false);
    } else {
      setBarcodeErr(true);
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchText(query);
    if (query.length > 0) {
      const filteredSuggestions = data?.filter(
        (item) =>
          item?.productName?.toLowerCase().includes(query.toLowerCase()) ||
          item?.gtin?.toLowerCase().includes(query.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (item) => {
    const itemIndex = data?.findIndex(
      (dataItem) => dataItem?.gtin === item?.gtin && dataItem?.batchNo === item?.batchNo
    );
    if (itemIndex !== -1) {
      setActiveRow(itemIndex);
      setShowModal(true);
      setSearchText("");
      setSuggestions([]);
    }
  };

  const handleChange = (event) => {
    const updatedArray = data.map((item) => ({
      ...item,
      // returnedQty: item.quantity,
      returnedQty: item.quantityBySpecs,
    }));

    setChecked(event.target.checked);
    if (event.target.checked) {
      dispatch(setReturnedItems(updatedArray));
    } else {
      dispatch(setReturnedItems([]));
    }
  };

  return (
    <div>
      <BarcodeReader
        onScan={handleScan}
        onError={(err, msg) => {
          if (err.length > 1) {
            if (msg === "Average key character time should be less or equal 90ms") {
              setBarcodeErr(false);
            }
            if (msg === "String length should be greater or equal 6") {
              setBarcodeErr(true);
            }
          }
        }}
        avgTimeByChar={120}
      />
      <p className="order-item-name">Original Item List</p>
      <div className="return-search-flex-box">
        <div className="return-wrapper-input-box">
          <SearchIcon className="return-search-icon" />
          <input
            tabIndex={-1}
            id="search-input"
            className="return-search-input"
            placeholder="Search product or GTIN"
            onChange={handleSearchChange}
            value={searchText}
          />
          {suggestions?.length > 0 && (
            <ul className="suggestions-dropdown">
              {suggestions?.map((item, index) => (
                <li
                  className="return-search-text"
                  key={index}
                  onClick={() => handleSuggestionClick(item)}
                >
                  {item?.productName} - {item?.gtin}
                </li>
              ))}
            </ul>
          )}
        </div>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            sx={{
              "& .MuiFormControlLabel-label": {
                fontWeight: 700,
              },
            }}
            label="Return all items"
          />
        </FormGroup>
      </div>
      <div className="order-details-container">
        <table ref={tableRef} className="custom-table no-outline" tabIndex={0}>
          <thead>
            <tr>
              <th className="table-small-column">Sn</th>
              <th colSpan={2}>Product</th>
              <th>Gtin</th>
              <th className="table-small-price">Mrp</th>
              <th className="table-small-price">Batch No</th>
              <th className="table-small-price">Selling Price</th>
              <th className="table-small-price">Original Qty</th>
            </tr>
          </thead>
          <tbody className="custom-table-body">
            {data.map((item, index) => (
              <tr
                key={item.id}
                className={`${activeRow === index ? "return-active-row" : ""} ${
                  isItemReturned(item?.gtin, item?.batchNo) ? "greyed-out-row" : ""
                }`}
                onClick={() => {
                  setActiveRow(index);
                  setShowModal(true);
                }}
                ref={activeRow === index ? activeRowRef : null}
              >
                <td className="table-small-column">{index + 1}</td>
                <td className="product-name-column" colSpan={2}>
                  {item?.productName}
                </td>
                <td>{item?.gtin}</td>
                <td className="table-small-price">{item?.mrp}</td>
                <td className="table-small-price">{item?.batchNo}</td>
                <td className="table-small-price">{item?.sellingPrice}</td>
                <td className="table-small-price">
                  {/* {item.weightsAndMeasures ? item?.quantityBySpecs : item?.quantity} */}
                  {item?.quantityBySpecs}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <QuantityValidationModal
          show={showModal}
          onClose={handleCloseModal}
          content={data[activeRow]}
          setShowModal={setShowModal}
        />
      </div>
      {barcodeErr && <p className="barcode-error">Error: Scanned barcode not found in item list</p>}
    </div>
  );
};
